import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ButtonItem } from "../../../../../entities/UIEntities/ButtonItem";
import { StepHeaderEntity } from "../../../../../entities/UIEntities/Form Entities/StepHeaderEntity";
import {
  ADD_PARKER_FORM_STEPS,
  INPUTS_PROPS
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Icons from "../../../../../resources/icons/Icons";
import Strings from "../../../../../resources/Strings";
import { isRequired } from "../../../../../utils/FormUtils";
import UserTypesButtons from "../../../Buttons/CustomToggleButton/UserTypesButtons/UserTypesButtons";
//import SitesSelectInput from "../../../Inputs/CustomInputs/SitesSelectInput";
import ScopesSelectInput from "../../../Inputs/CustomInputs/ScopesSelectInput";
import classes from "../WizardForm.module.css";

const UserRoleStep = (props) => {
  const userRoles = useSelector((state) => state.user.initialState.roles);
  const [errors, setErrors] = useState({});
  const [selectedScope, setSelectedScope] = useState(props.scopesList[0]);
  useEffect(() => {
    if (props.currentStep === ADD_PARKER_FORM_STEPS.ADD_PERMISSIONS) {
      const stepHeader = new StepHeaderEntity(
        props.isEditMode
          ? Strings.STEPS_TITLES.USER_ROLE_EDIT_MODAL_TITLE
          : Strings.STEPS_TITLES.USER_ROLE_MODAL_TITLE,
        props.isEditMode
          ? ""
          : "",
        Icons.ADD_ROLE,
        null
      );

      store.dispatch(commonActions.setSideModal({ modalHeader: stepHeader }));

      const hasError = Object.values(errors).some((error) => !error.isValid);
      props.handleCurrentStepValidity(hasError);
    }
  }, [errors]);

  useEffect(() => {
    validateStep();
  }, [/*props.site,*/ props.role, props.currentStep]);

  const validateStep = () => {
    setErrors({
      ...errors,
      userTypeValue: isRequired(props.role),
      //siteValue: isRequired(props.site),
    });
  };

  const handleRoleChange = (event, role) => {
    const eventValue = { [INPUTS_PROPS.ROLE]: role };
    props.handleChange(eventValue);
  };

  if (
    props.currentStep !== ADD_PARKER_FORM_STEPS.EDIT_STEP &&
    props.currentStep !== ADD_PARKER_FORM_STEPS.ADD_PERMISSIONS
  ) {
    return null;
  }

const selectScopeId = (scopeId) => {
  let scope = props.scopesList.find(scope => scope.id === scopeId)
  if (scope) {
    const eventValue = { [INPUTS_PROPS.SCOPE]: scope }; // update form data on PermissionsForm
    props.handleChange(eventValue); // added
    setSelectedScope(scope);
  }
}

const getSubTitle = () => {
  if (props?.scopesList?.length > 0) {
    if (props.isEditMode) {
      return Strings.STEPS_TITLES.USER_ROLE_SUB_EDIT_TITLE;
    }
    else {
      return Strings.STEPS_TITLES.USER_ROLE_SUB_TITLE;
    }
  } 
  else {
    return Strings.STEPS_TITLES.USER_ROLE_NO_AVAILABLE_FACILITIES_SUB_TITLE;
  }
};

const getRoleFromSelectedScope = (selectedScope) => {
  let userScope =  props.userScopes.find(userScope => userScope.scopeId === selectedScope.id);
  if (userScope) {
    return userScope.roleId;
  }
  //return selectedScope.role;
};

  return (
    <div className={classes.stepContainer}>
      <div className={classes.stepTitle}>
        {props.isEditMode ? Strings.STEPS_TITLES.USER_ROLE_EDIT_TITLE : Strings.STEPS_TITLES.USER_ROLE_TITLE}
      </div>
      <span className={classes.stepSubTitle}>
      {/* {props.isEditMode ? Strings.STEPS_TITLES.USER_ROLE_SUB_EDIT_TITLE : Strings.STEPS_TITLES.USER_ROLE_SUB_TITLE} */}
      {getSubTitle()} 
      </span>
      {!props.isEditMode && props?.scopesList?.length > 0 && (
        <ScopesSelectInput
          label={Strings.INPUT_LABELS.FACILITY}
          id={INPUTS_PROPS.SITE}
          onChange={props.handleChange}
          list={props.scopesList} // list={props.sitesList}
          value={props.scopesList?.length > 0 ? props.scopesList[0]?.id : 0} // value={props.sitesList?.length > 0 ? props.sitesList[0].id : 0}
          selectScopeId={selectScopeId}
          //   handleError={handleError}
          //   hasError={!isEmail(props.email).isValid}
          //   errorMessage={getErrorMessage(isEmail(props.email))}
        />
      )}
      <div className={classes.rolesContainer}>
        {props?.scopesList?.length > 0 && 
          <UserTypesButtons
          buttonsList={userRoles
            // .filter((userType) => userType.siteId === siteValue)
            .map((role) => new ButtonItem(role.id, role.name))}
          selectedValue={props.role ? props.role : getRoleFromSelectedScope(selectedScope)}
            // selectedValue={props.role}
          id={INPUTS_PROPS.ROLE}
          handleChange={handleRoleChange}
          isEditMode={props.isEditMode}
        />
        }
        
      </div>
    </div>
  );
};

export default UserRoleStep;
